export const PAGE_CHANGE_MESSAGE_BUS_TOPIC = 'navigation.pageChanged';
export const BEFORE_PAGE_CHANGE_MESSAGE_BUS_TOPIC = 'navigation.beforePageChange';
